<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Integrada"
        class="logo"
      />

      <div class="texts">
        <h2>{{titulo}}</h2>
        <p class="subtitle">Crie uma nova senha segura para sua conta</p>
      </div>

      <form
        [formGroup]="senhaFormGroup"
        (ngSubmit)="enviarNovaSenha()"
        class="form-fields"
      >
        <!-- Campo Nova Senha -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nova Senha</mat-label>
          <input
            matInput
            formControlName="senha"
            type="password"
            (input)="onPasswordInput($event)"
          />
        </mat-form-field>

        <!-- Dicas de Validação -->
        <div
          class="password-hints-container"
          [class.all-valid]="validationState.senhaValid"
        >
          <div class="password-hints">
            <div
              class="hint-item"
              [class.valid]="passwordRequirements.minLength"
            >
              <mat-icon [class.dot]="!passwordRequirements.minLength"
                >{{ passwordRequirements.minLength ? 'check' :
                'fiber_manual_record' }}</mat-icon
              >
              <span>Mínimo 8 caracteres</span>
            </div>
            <div
              class="hint-item"
              [class.valid]="passwordRequirements.upperCase"
            >
              <mat-icon [class.dot]="!passwordRequirements.upperCase"
                >{{ passwordRequirements.upperCase ? 'check' :
                'fiber_manual_record' }}</mat-icon
              >
              <span>Letra maiúscula</span>
            </div>
            <div
              class="hint-item"
              [class.valid]="passwordRequirements.lowerCase"
            >
              <mat-icon [class.dot]="!passwordRequirements.lowerCase"
                >{{ passwordRequirements.lowerCase ? 'check' :
                'fiber_manual_record' }}</mat-icon
              >
              <span>Letra minúscula</span>
            </div>
            <div
              class="hint-item"
              [class.valid]="passwordRequirements.number || passwordRequirements.specialChar"
            >
              <mat-icon [class.dot]="!passwordRequirements.number"
                >{{ (passwordRequirements.number ||
                passwordRequirements.specialChar) ? 'check' :
                'fiber_manual_record' }}</mat-icon
              >
              <span>Número ou caractere especial</span>
            </div>
          </div>
        </div>

        <!-- Campo Confirmar Senha -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirmar Nova Senha</mat-label>
          <input
            matInput
            formControlName="confirmarSenha"
            type="password"
            (input)="onConfirmacaoInput($event)"
            [class.invalid]="confirmarSenhaRequirements.touched && !confirmarSenhaRequirements.equals"
          />
          <mat-error
            *ngIf="confirmarSenhaRequirements.touched && !confirmarSenhaRequirements.equals"
          >
            As senhas não coincidem
          </mat-error>
        </mat-form-field>

        <div
          class="password-confirm-hints-container"
          [class.all-valid]="validationState.confirmacaoValid"
        >
          <div class="confirm-password-hints">
            <div
              *ngIf="!confirmarSenhaRequirements.equals"
              class="hint-item"
              [class.valid]="confirmarSenhaRequirements.equals"
            >
              <mat-icon [class.dot]="!confirmarSenhaRequirements.equals"
                >{{ (confirmarSenhaRequirements.equals) ? 'check' :
                'warning_rounded' }}</mat-icon
              >
              <span>As senhas não coincidem.</span>
            </div>
          </div>
        </div>

        <button
          mat-raised-button
          color="primary"
          class="submit-button"
          type="submit"
          [disabled]="!isFormValid()"
          [style.opacity]="isFormValid() ? 1 : 0.5"
        >
          Salvar senha
        </button>
      </form>

      <!-- Link para voltar -->
      @if(!isPrimeiroAcesso) {
      <div class="return" (click)="voltarParaLogin()">
        <img src="assets/svg/icons/arrow_left.svg" alt="Ícone de voltar" />
        <p>Voltar para login</p>
      </div>
      }

      <!-- Logo SESI -->
      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
